module.exports = __webpack_public_path__ + "static/media/arrow-clockwise.0025d6ca.svg";